export default "__VITE_ASSET__Mi_cqKGC6myK5zNnDLjCMA__"